<ds-border-wrapper>
  <div class="d-flex align-items-center justify-content-between w-100 payment-info">
    <div class="d-flex align-items-center g-2">
      @if (icon) {
        <img src="assets/images/{{ icon }}.webp" alt="paying system" />
      }
      <p>{{ name }}</p>
      <div class="d-flex align-items-center payment-info-dots">
        <ds-dot-separator class="payment-info-dots-item" />
        <ds-dot-separator class="payment-info-dots-item" />
        <ds-dot-separator class="payment-info-dots-item" />
        <ds-dot-separator class="payment-info-dots-item" />
      </div>
      <p>{{ cardNumber }}</p>
    </div>
    <h3 class="bold">
      <span [innerHTML]="amount | portalCurrency"></span>
    </h3>
  </div>
</ds-border-wrapper>
